import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  Table,
  Avatar,
  Breadcrumb,
  Modal,
  Button,
  message,
  Popconfirm,
  Tag,
  Form,
  Input,
  Tooltip,
  Segmented,
} from "antd";
import axios from "axios";
import { SERVER_ADDRESS } from "../../Config/Config";
import { EyeOutlined, UserOutlined } from "@ant-design/icons";
import { FaBan, FaTrashAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
const { TextArea } = Input;

const ReportList = () => {
  const userData = JSON.parse(
    atob(localStorage.getItem("token").split(".")[1])
  );
  const userPermission = userData.privelege || [];
  const { id } = useParams(); // Get user ID from URL
  const [loading, setLoading] = useState(true);
  const [reportedByUsers, setReportedByUsers] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [description, setDescription] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const is_suspend = location.state?.is_suspend;
  const [suspendModal, setSuspendModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [susForm] = Form.useForm();
  const [segment, setSegment] = useState("All Reports"); // default segment

  const showModal = (record) => {
    setOpenModal(true);
    setDescription(record);
  };

  const handleCancel = () => {
    setOpenModal(false);
  };

  const handleSuspendClose = () => {
    setSuspendModal(false);
    susForm.resetFields();
  };

  const handleReportDelete = async (id) => {
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/deleteReport`, {
        id,
      });
      if (response.status === 200) {
        const updatedUser = reportedByUsers.filter(
          (item) => item.report_id !== id
        );
        setReportedByUsers(updatedUser);
        if (updatedUser.length === 0) {
          navigate("/reportedUsers");
        }
        message.success({ content: `${response.data.message}` });
      }
    } catch (error) {
      message.error({ content: "Oops Something Went Wrong !" });
    }
  };

  useEffect(() => {
    const fetchReportedByUsers = async () => {
      try {
        const response = await axios.get(
          `${SERVER_ADDRESS}/api/particularReport/${id}`
        );
        if (response.status === 200) {
          setReportedByUsers(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setLoading(false);
    };

    fetchReportedByUsers();
  }, [id]);

  const columns = [
    { title: "ID", dataIndex: "id", key: "id", sorter: (a, b) => a.id - b.id },
    {
      title: "Profile",
      dataIndex: "profile",
      key: "profile",
      render: (_, record) => {
        return record.profile ? (
          <Avatar size={64} src={record.profile} />
        ) : (
          <Avatar size={64} icon={<UserOutlined />} />
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Phone", dataIndex: "phone", key: "phone" },
    {
      title: "Report Type",
      dataIndex: "type",
      key: "type",
      render: (_, record) => {
        var reportType = "";
        if (record.type === "1") {
          reportType = "Toxic Behavior";
        } else if (record.type === "2") {
          reportType = "Abusive Language";
        } else if (record.type === "3") {
          reportType = "Fake Profile";
        } else if (record.type === "4") {
          reportType = "Inappropriate Content";
        } else if (record.type === "5") {
          reportType = "Scam or Fraud";
        } else if (record.type === "6") {
          reportType = "Harassment";
        } else if (record.type === "7") {
          reportType = "Unwanted Contact";
        } else if (record.type === "8") {
          reportType = "Privacy Concerns";
        } else if (record.type === "9") {
          reportType = "Mismatched Intentions";
        } else if (record.type === "10") {
          reportType = "Repeated Disturb";
        }
        return <span>{reportType}</span>;
      },
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => a.created_at.localeCompare(b.created_at),
    },
    {
      title: "View",
      key: "view",
      render: (_, record) => {
        return (
          <div className="d-flex flex-row gap-2">
            <Tooltip title="View Description">
              <Button
                color="primary"
                variant="filled"
                onClick={() => showModal(record.description)}
              >
                <EyeOutlined />
              </Button>
            </Tooltip>
            <Tooltip title="Delete Report">
              <Popconfirm
                onConfirm={() => handleReportDelete(record.report_id)}
                title="Are You Sure Want to delete this Report ?"
              >
                <Button color="red" variant="filled">
                  <FaTrashAlt />
                </Button>
              </Popconfirm>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const breadcrumbItems = [
    {
      path: "/dashboard",
      title: "Home",
    },
    {
      path: "/reportedUsers",
      title: "Report Users",
    },
  ];

  const handleSuspend = async (values) => {
    try {
      const response = await axios.post(
        `${SERVER_ADDRESS}/api/suspendAccount`,
        {
          id: selectedId,
          suspend_reason: values.suspend_reason,
          type: 1,
        }
      );
      const result = response.data;
      if (result.result === 1) {
        handleSuspendClose();
        message.success({ content: "Account Suspended" });
        navigate("/reportedUsers");
      }
    } catch (error) {
      console.log(error);
      message.error({ content: "Something Went Wrong" });
    }
  };

  return (
    <>
      <div
        className="d-flex flex-row justify-content-between"
        style={{ marginTop: "4rem" }}
      >
        <h3>Reported By Users</h3>
        <Breadcrumb>
          {breadcrumbItems.map((item, index) => (
            <Breadcrumb.Item key={index}>
              <Link to={item.path}>{item.title}</Link>
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </div>
      <div className="flex flex-col" style={{ marginTop: "4rem" }}>
        {userPermission.includes("suspend") && (
          <div>
            {(is_suspend !== 1 && (
              <div className="mb-3">
                Click here to Suspend this account :
                <Button
                  onClick={() => {
                    setSuspendModal(true);
                    setSelectedId(id);
                  }}
                  color="danger"
                  variant="filled"
                >
                  <FaBan />
                </Button>
              </div>
            )) || (
              <Tag className="mb-3" color="red">
                Account already suspended
              </Tag>
            )}
          </div>
        )}
        <div style={{ marginBottom: "1rem" }}>
          <Segmented
          block
            options={[ "All Reports","User Reports", "Video Reports"]}
            value={segment}
            onChange={setSegment}
          />
        </div>

        <Table
          rowKey="id"
          dataSource={reportedByUsers.filter((report) => {
            if (segment === "User Reports") return report.report_type === 1;
            if (segment === "Video Reports") return report.report_type === 2;
            return true;
          })}
          columns={columns}
          loading={loading}
        />
      </div>
      <Modal
        title="Report Description"
        open={openModal}
        onCancel={handleCancel}
        footer={false}
      >
        <p>{description}</p>
      </Modal>
      <Modal
        title="Suspend Account"
        open={suspendModal}
        onCancel={handleSuspendClose}
        footer={false}
      >
        <Form form={susForm} onFinish={handleSuspend}>
          <Form.Item
            name="suspend_reason"
            rules={[
              { required: "true", message: "Enter Suspend Description" },
              {
                pattern: /^(?:\s*\S){10,}.*$/,
                message: "Must be atleast 10 characters",
              },
            ]}
          >
            <TextArea
              showCount
              maxLength={250}
              placeholder="Enter Details about suspend"
              rows={4}
            />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 9 }}>
            <Button type="primary" htmlType="submit">
              Suspend
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ReportList;
